export function NavbarRewards({
  activeMenuItem,
}: Readonly<Pick<HeaderAccountProps, 'activeMenuItem'>>) {
  const getOpacity = (index: number) => {
    return {
      opacity: activeMenuItem === index ? 1 : 0.5,
    }
  }
  return (
    <header className="">
      <nav className="flex items-center mx-auto justify-evenly md:justify-center w-full gap-1 md:gap-2">
        <li className="list-none w-full justify-center flex-col flex h-20 relative items-center">
          <div
            className={`w-full h-1 rounded-full mb-1.5  ${activeMenuItem === 0 ? 'bg-[#4F46E5]' : 'bg-gray-300 dark:bg-gray-600'} `}
          />

          <div className="flex items-center gap-3">
            <p
              className={`${activeMenuItem === 0 ? 'text-[#4F46E5]' : 'text-gray-300 dark:text-gray-600 '} text-xs md:text-base font-medium`}
            >
              {window.innerWidth < 768 ? 'Colaborador' : 'Escolher Colaborador'}
            </p>

            <div
              className="w-6 h-6 bg-[#635cf0] rounded-full flex justify-center items-center "
              style={getOpacity(0)}
            >
              <p className="text-xs text-white">
                {activeMenuItem === 0 && '1'}
                {activeMenuItem > 0 && '✓'}
              </p>
            </div>
          </div>
        </li>
        <li className="list-none w-full justify-center flex flex-col h-20 relative items-center">
          <div
            className={`w-full h-1 rounded-full mb-1.5 ${activeMenuItem === 1 ? 'bg-[#4F46E5]' : 'bg-gray-300 dark:bg-gray-600'}`}
          />

          <div className="flex items-center gap-3">
            <p
              className={`${activeMenuItem === 1 ? 'text-[#4F46E5]' : 'text-gray-300 dark:text-gray-600'} text-xs md:text-base font-medium`}
            >
              {window.innerWidth < 768 ? 'Premiação' : 'Definir Premiação'}
            </p>

            <div
              className="w-6 h-6 bg-[#4F46E5] rounded-full flex justify-center items-center"
              style={getOpacity(1)}
            >
              <p className="text-xs text-white">
                {activeMenuItem <= 1 && '2'}
                {activeMenuItem > 1 && '✓'}
              </p>
            </div>
          </div>
        </li>
        <li
          className="list-none w-full justify-center flex flex-col h-20 relative items-center"
          id="reservations"
        >
          <div
            className={`w-full h-1 rounded-full mb-1.5 ${activeMenuItem === 2 ? 'bg-[#4F46E5]' : 'bg-gray-300 dark:bg-gray-600'}`}
          />
          <div className="flex items-center gap-3">
            <p
              className={`${activeMenuItem === 2 ? 'text-[#4F46E5]' : 'text-gray-300 dark:text-gray-600'} text-xs md:text-base font-medium`}
            >
              Confirmação
            </p>

            <div
              className="w-6 h-6 bg-[#4F46E5] rounded-full flex justify-center items-center"
              style={getOpacity(2)}
            >
              <p className="text-xs text-white">
                {activeMenuItem <= 2 && '3'}
                {activeMenuItem > 2 && '✓'}
              </p>
            </div>
          </div>
        </li>
      </nav>
    </header>
  )
}
